
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  progressPercentage: number;
}

const ProgressBar = ({ progressPercentage }: ProgressBarProps) => {
  return (
    <div className="relative h-3 bg-gray-100 rounded-full overflow-hidden mb-8 shadow-inner">
      <div 
        className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-accent transition-all duration-500 ease-out"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
